<template>
  <div class="row document">
    <div class="col-sm-4" v-for="page in pages" :key="page.name">
      <div class="card card-document" @click="open(page.value)">
        <div class="card-body text-center">
          <strong>
            {{ page.name }}
          </strong>
        </div>
      </div>
    </div>

    <Modal v-model="scheduleModal">
      <div slot="header">
        <h3>Schedule (Agenda)</h3>
      </div>
      <div class="schedule">
        {{ schedule }}
      </div>
    </Modal>

    <Modal v-model="rulesModal">
      <div slot="header">
        <h3>Regras de Negócios</h3>
      </div>
      <div class="event-detail">
        <VueJsonPretty :data='rules'
                       :deep='2'
                       :showLength='true'
                       :showLine='true'/>
      </div>
    </Modal>

    <Modal v-model="tasksModal">
      <div slot="header">
        <h3>Tasks</h3>
      </div>
      <div class="row">
        <div class="form-group col-sm-12" v-for="array in tasks" :key="array[0]">
          <label>{{ array[0] }}</label>
          <input :value="array[1]" class="form-control" disabled>
        </div>
      </div>
    </Modal>

    <Loading :load="load" message="Carregando Documentação"/>
  </div>
</template>

<script>
  import Loading from '@/components/shares/Loading'
  import Modal from '@/components/shares/specialTag/Modal'
  import VueJsonPretty from 'vue-json-pretty'

  export default {
    components: { Loading, Modal, VueJsonPretty },
    created() {
      this.axios.get('admin/documents')
        .then(response => {
          this.schedule = response.schedule
          this.tasks = response.tasks
          this.rules = response.rules
        })
    },
    data() {
      return {
        load: false,
        pages: [
          { name: 'Regras de Negócios', value: 'rules' },
          { name: 'Tasks', value: 'tasks' },
          { name: 'Schedule (Agenda)', value: 'schedule' }
        ],
        rules: null,
        rulesModal: false,
        schedule: null,
        scheduleModal: false,
        tasks: null,
        tasksModal: false
      }
    },
    methods: {
      open(name) {
        this[`${name}Modal`] = true
      }
    },
    name: 'Document'
  }
</script>

<style scoped>

  .document {
    position: relative;
  }

  .schedule {
    white-space: pre-wrap;
    color: black;
  }

  .event-detail * {
    background: #051724;
    color: #FFF;
    padding: 16px;
    border-radius: 8px;
  }

  .card-document {
    cursor: pointer;
  }
  .card-document:hover {
    transition: background-color 1s;
    background: #8080803d;
  }

</style>